import * as React from 'react';
import { styled } from '@mui/material/styles';

import { NotificationData } from '../../types/NotificationData';
import { AlertControl } from './AlertControl';

const AlertMessage = styled('div')(({}) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > *': {
    width: '100%',
    margin: 0,
  },
  '& .MuiAlertTitle-root': {
    fontSize: '14px !important',
    marginTop: '1px !important',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif !important',
  },
}));

export interface NotificationProps {
  onClose?: (event: any, reason: any) => void;
  data: NotificationData;
  children?: React.ReactNode;
}
export const Notification = (props: NotificationProps) => {
  const { data, onClose, children } = props;

  return (
    <AlertMessage>
      <AlertControl
        title={data?.title}
        severity={data?.messageType}
        message={data?.message}
        onClose={onClose}
      >
        <div className="MuiAlertTitle-root">{children}</div>
      </AlertControl>
    </AlertMessage>
  );
};
